import { createFileRoute } from "@tanstack/react-router";
import AdminChats from "@/pages/admin/AdminChats";

export const Route = createFileRoute("/_adminLayout/admin/chats")({
  component: AdminChats,
});
